import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { Observable } from 'rxjs';

import { Antwoord, Vraag } from '@models/claims';
import { IBaseVraagboomResultaat, Meetgegevens, VraagboomAntwoord, VraagboomDateVanTotResultaat } from '@models/vragenboom';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { DatumValidator } from '../../../utils/validation/datum.validator';
import { DataService } from '../../../services/data.service';
import { MetenMapper } from '../../../mappers/meten.mapper';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-date-van-tot-picker',
  templateUrl: './date-van-tot-picker.component.html',
  styleUrls: ['./date-van-tot-picker.component.scss'],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class DateVanTotPickerComponent extends BaseVraagControlDirective<VraagboomDateVanTotResultaat> implements OnInit {
  @Input() isCurrentVraag: boolean;

  meetId: string;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];
  meetgegevens: Meetgegevens;

  errorMessage = '';
  validDates: boolean;
  minDatumVan = null;
  maxDatumVan = new Date(2099, 0, 1);
  minDatumTot = null;
  maxDatumTot = new Date(2099, 0, 1);
  _datumVan: Date;
  _datumTot: Date;
  datumInitVan: Date = null;
  datumInitTot: Date = null;
  set datums(val: string) {
    if (val) {
      this._datumVan = null;
      this._datumTot = null;
      var dateSplit;
      var dates = val.split('#');
      if (dates?.length > 0) {
        dateSplit = dates[0].split('-');
        this._datumVan = new Date(Number(dateSplit[0]), Number(dateSplit[1]), Number(dateSplit[2]));
      }
      if (dates?.length > 1 && dates[1]) {
        dateSplit = dates[1].split('-');
        this._datumTot = new Date(Number(dateSplit[0]), Number(dateSplit[1]), Number(dateSplit[2]));
      }
      this.notifyAntwoord(this._datumVan, this._datumTot);
    } else {
      this.notifyAntwoord(null, null);
    }
  }

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() { }

  initialize(changes: SimpleChanges): void {
    if (!this.isCurrentVraag) { return; }

    this.meetgegevens = this._dataService.getMeetgegevens();
    this.meetId = this._dataService.getMeetidPazaProces() + '-' + this.meetgegevens.status + this.meetgegevens.sleutel +
      MetenMapper.geefVolgnr(this.vraag, this.meetgegevens.reeks) + '_' + MetenMapper.format(this.vraag.titel);

    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.resultaten = res;
          this.verwerkResultaat();
        }
      });
  }

  verwerkResultaat(): void {
    let kleinerGelijk, groterGelijk;

    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null) {
      this._datumVan = this.antwoordResultaat.resultaat.van;
      this._datumTot = this.antwoordResultaat.resultaat.tot;
      this.datumInitVan = this._datumVan;
      this.datumInitTot = this._datumTot;
    } else {
      this._datumVan = new Date();
    }

    if (this.vraag?.antwoorden?.length === 2) {
      // van
      kleinerGelijk = this.vraag.antwoorden[0].validatieParameters.find(v => v.type_validatie === 'DATUM_KLEINER_GELIJK');
      if (kleinerGelijk != null) {
        this.maxDatumVan = DatumValidator.getComparisonDate(kleinerGelijk.validatie_parameters, this.resultaten);
      }
      groterGelijk = this.vraag.antwoorden[0].validatieParameters.find(v => v.type_validatie === 'DATUM_GROTER_GELIJK');
      if (groterGelijk != null) {
        this.minDatumVan = DatumValidator.getComparisonDate(groterGelijk.validatie_parameters, this.resultaten);
      }
      // tot
      kleinerGelijk = this.vraag.antwoorden[1].validatieParameters.find(v => v.type_validatie === 'DATUM_KLEINER_GELIJK');
      if (kleinerGelijk != null) {
        this.maxDatumTot = DatumValidator.getComparisonDate(kleinerGelijk.validatie_parameters, this.resultaten);
      }
      groterGelijk = this.vraag.antwoorden[1].validatieParameters.find(v => v.type_validatie === 'DATUM_GROTER_GELIJK');
      if (groterGelijk != null) {
        this.minDatumTot = DatumValidator.getComparisonDate(groterGelijk.validatie_parameters, this.resultaten);
      }
      this.errorMessage = "Kies alsjeblieft de " + this.vraag.antwoorden[0].overzicht_gemeld_links?.toLowerCase() + " en de " + this.vraag.antwoorden[1].overzicht_gemeld_links?.toLowerCase();
    }
  }

  onReset() {
    this.notifyAntwoord(null, null);
  }

  notifyAntwoord(datumVan: Date, datumTot: Date) {
    const antwoorden: Antwoord[] = [];
    if (this.vraag?.antwoorden?.length === 2) {
      antwoorden.push(this.vraag.antwoorden[0]);
      antwoorden.push(this.vraag.antwoorden[1]);
    }
    this.setAntwoord(antwoorden, new VraagboomDateVanTotResultaat(datumVan, datumTot));
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomDateVanTotResultaat): boolean {
    this.validDates = false;
    if (!this.resultaten) {
      return false;
    }
    this.validDates = DatumValidator.isValidDateVanTot(antwoorden, resultaat) &&
      DatumValidator.isVanTotSmallerThan(antwoorden, resultaat, this.resultaten) &&
      DatumValidator.isVanTotGreaterThan(antwoorden, resultaat, this.resultaten);
    return this.validDates;
  }
}
